import React from 'react';
import UserChallengeComplete from 'modules/challenges/UserChallengeComplete.js';


const SurveyComplete = ({result, onClose, completePercent}) => (
    <UserChallengeComplete progress={result.progress} onContinue={onClose}  />
);

export default SurveyComplete;



// WEBPACK FOOTER //
// ./src/modules/surveys/SurveyComplete.js